import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleMenu, currentRole } from '../store/reducers/menu_reducer';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { get_auth_key, storeData, getStoredData, addLocalStorageItem, exposedRoutes } from '../util';
import { logout } from '../services/apiController';
import { setUserLogout } from '../store/reducers/account_reducer';
import { Stack, Form } from 'react-bootstrap';
import { signOutClearLocalStorage } from '../util/auth';
import axios from '../services/axios-config.js';
import { upsertLocalStorageDetails } from '../helpers/auth.helper.js';

const Banner = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const storedData = JSON.parse(getStoredData(get_auth_key()));
  const [isProfileMenuOpen, setProfileMenuOpen] = useState(false);
  const userRoles = useSelector((state) => state.account.userRoles);
  const activeRole = useSelector((state) => state?.menu?.role);

  const handleLogout = async (e) => {
    e.preventDefault();
    try {
      await logout();
      signOutClearLocalStorage();
      dispatch(setUserLogout());
    } catch (err) {
      toast.error(err.message, { autoClose: 3000 });
    }
    navigate('/');
  };

  const onRoleChange = async (e) => {
    const role = e.target.value;
    // Fetching the token for this role from the server
    const meCallResponse = await axios.get('/v1/users/me');
    const roleToken = meCallResponse.data.data.tokens.find((token) => token.role === role);
    if (!roleToken) {
      toast.error('Role not found', { autoClose: 3000 });
      return;
    }
    const dataToStore = {
      displayName: meCallResponse.data.data.name,
      role: role,
      token: roleToken.token,
      locationId: roleToken.locationId,
      companyId: roleToken.companyId,
    };
    upsertLocalStorageDetails(dataToStore, 'role');
    // If role is vehicle manage, then setting up 0 index by default
    if (roleToken.locationId && role === 'vehicle-manager') {
      addLocalStorageItem('factoryId', roleToken.locationId?.[0]);
    }
    if (roleToken.locationId && role === 'machine-manager') {
      addLocalStorageItem('factoryId', roleToken.locationId?.[0]);
    }
    dispatch(currentRole(role));
    // Check if current route is one of the exposed routes before navigating
    const currentPath = window.location.pathname;
    const isExposedRoute = exposedRoutes.some((route) => currentPath.startsWith(route));

    if (!isExposedRoute) {
      navigate('/dashboard');
    }
  };

  return (
    <nav className="my-navbar sticky-top">
      <div className="my-navbar-toggler" onClick={() => dispatch(toggleMenu())}>
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-list" viewBox="0 0 16 16">
          <path
            fillRule="evenodd"
            d="M2.5 11.5A.5.5 0 0 1 3 11h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 7h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 3h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
          />
        </svg>
      </div>
      <div className="my-navbar-brand">
        <Link>
          <img src={`${process.env.PUBLIC_URL}/logo70.png`} alt="Brand logo" className="my-brand-logo" />
        </Link>
      </div>
      <Stack direction="horizontal" className="w-100">
        <div className="my-navbar-items me-auto not-in-mobile">
          <div className="my-nav-item banner-name">ERP</div>
        </div>
        <div className="d-flex align-items-center gap-4">
          <div className="mr-3">
            <Stack direction="horizontal" gap={2} className="align-items-center justify-content-center">
              <Form.Label htmlFor="inputPassword5" className="m-0 text-white">
                Role:
              </Form.Label>
              <Form.Select aria-label="Default select example" value={activeRole} onChange={onRoleChange}>
                <option>Select Role</option>
                {userRoles.map((role, index) => (
                  <option key={index} value={role}>
                    {role}
                  </option>
                ))}
              </Form.Select>
            </Stack>
          </div>
          <div className="my-profile-toggler" onClick={() => setProfileMenuOpen(!isProfileMenuOpen)} style={{ position: 'relative' }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              className="bi bi-person-lines-fill"
              viewBox="0 0 16 16"
            >
              <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2z"></path>
            </svg>
            <div
              role="menu"
              className={isProfileMenuOpen ? 'dropdown-menu dropdown-menu-right show' : 'dropdown-menu dropdown-menu-right'}
              style={{
                position: 'absolute',
                willChange: 'transform',
                top: '0px',
                right: '0px',
                transform: 'translate3d(5px, 45px, 0px)',
                textAlign: 'unset',
              }}
              x-placement="bottom-end"
            >
              <div className="account-micro-view" style={{ padding: '0 1rem' }}>
                <Link to="/userprofile" style={{ textDecoration: 'none', color: 'black' }}>
                  <p className="mb-0">{storedData?.displayName}</p>
                </Link>
              </div>
              <a
                onClick={handleLogout}
                className="logout-btn dropdown-item"
                style={{ padding: '0 1rem', color: '#dd2c00', backgroundColor: '#efefef', fontSize: '14px' }}
              >
                Logout
              </a>
            </div>
          </div>
        </div>
      </Stack>
    </nav>
  );
};

export default Banner;
